export default function isFunc (obj) {
  return (typeof obj) === 'function';
}


// WEBPACK FOOTER //
// ./src/isFunc.js